var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCreditunits = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_24379",
  "data-name": "Group 24379",
  transform: "translate(-427 -205)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_2936",
  "data-name": "Rectangle 2936",
  width: 24,
  height: 24,
  transform: "translate(427 205)",
  fill: "#e3e3e3",
  opacity: 0
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_24375",
  "data-name": "Group 24375",
  transform: "translate(-29.26 -60.381)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Union_6",
  "data-name": "Union 6",
  d: "M2.815,16A2.941,2.941,0,0,1,0,12.953v-9.9A2.943,2.943,0,0,1,2.815,0H14.78a2.942,2.942,0,0,1,2.812,3.049v.76H16.537v-.76A1.839,1.839,0,0,0,14.78,1.143H2.815A1.839,1.839,0,0,0,1.056,3.049v9.9a1.836,1.836,0,0,0,1.758,1.9H14.78a1.836,1.836,0,0,0,1.757-1.9V12.19H9.148A1.468,1.468,0,0,1,7.74,10.666V5.333A1.467,1.467,0,0,1,9.148,3.812h8.443A1.468,1.468,0,0,1,19,5.333v5.333a1.468,1.468,0,0,1-1.409,1.524v.763A2.94,2.94,0,0,1,14.78,16ZM8.8,5.333v5.333a.368.368,0,0,0,.352.381h8.443a.369.369,0,0,0,.353-.381V5.333a.366.366,0,0,0-.353-.379H9.148A.365.365,0,0,0,8.8,5.333ZM9.853,8a1.058,1.058,0,1,1,2.11,0,1.059,1.059,0,1,1-2.11,0Z",
  transform: "translate(460.259 270.88)",
  fill: "#484747"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_24373",
  "data-name": "Group 24373",
  transform: "translate(457.259 268.176)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_191",
  "data-name": "Ellipse 191",
  transform: "translate(0.001 -0.295)",
  fill: "#27a36a",
  stroke: "#fff",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("circle", {
  cx: 7,
  cy: 7,
  r: 7,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 7,
  cy: 7,
  r: 6.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_24333",
  "data-name": "Group 24333",
  transform: "translate(3.354 3.059)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_2065",
  "data-name": "Path 2065",
  d: "M6.837,4.1a.454.454,0,0,1-.322-.134L3.646,1.1.778,3.969a.456.456,0,0,1-.645-.645L3.324.134a.456.456,0,0,1,.645,0L7.159,3.324a.456.456,0,0,1-.322.778Z",
  transform: "translate(0.001 0.001)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2066",
  "data-name": "Path 2066",
  d: "M.456,7.293A.456.456,0,0,1,0,6.837V.456a.456.456,0,0,1,.912,0V6.837A.456.456,0,0,1,.456,7.293Z",
  transform: "translate(3.192 0.001)",
  fill: "#fff"
})))))));
export { SvgCreditunits as ReactComponent };
export default __webpack_public_path__ + "static/media/Creditunits.79de056ef289dc71a917addc9a6c8974.svg";